import { getChildrenByComponent } from '@app/utils/getChildrenByComponent';
import React from 'react';

import { RadioCard } from './RadioCard';

interface Props<T extends string> {
  className?: string;
  describedById?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  itemClassName?: string;
  labelledById?: string;
  name: string;
  value: T;
  onChange: (value: T) => void;
  errorMessageId?: string;
}
export const RadioCards = <T extends string>({
  className,
  describedById,
  isDisabled = false,
  labelledById,
  name,
  value,
  onChange,
  isLoading,
  children,
  errorMessageId,
}: React.WithChildren<Props<T>>) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as T);
  };
  const validChildren = getChildrenByComponent(children, RadioCard);
  const mappedChildren = validChildren.map(child =>
    React.cloneElement(child, { errorMessageId, isDisabled, isLoading, name, onChange: handleChange, selectedValue: value }),
  );

  return (
    <div role="radiogroup" aria-labelledby={labelledById} aria-describedby={describedById} className={className}>
      {mappedChildren}
    </div>
  );
};
